/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Delete_MsgInputs */



/**
* | output |
* | --- |
* | "This will permanently delete this tournament. This action cannot be undone." |
*
* @param {Tournament_Delete_MsgInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_delete_msg = /** @type {((inputs?: Tournament_Delete_MsgInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Delete_MsgInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Cela supprimera définitivement ce tournoi. Cette action ne peut pas être annulée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Esto eliminará permanentemente este torneo. Esta acción no se puede deshacer.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Isso excluirá permanentemente este torneio. Esta ação não pode ser desfeita.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questo eliminerà permanentemente questo torneo. Questa azione non può essere annullata.")
	return /** @type {LocalizedString} */ ("This will permanently delete this tournament. This action cannot be undone.")
});